import React, { useState, useEffect } from 'react';
import { Input, DatePicker, Radio, Select, Button, Slider, Switch, InputNumber,App } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { eventBus } from '@/utils/eventBus';
import styles from './GoLiveNow.module.scss';
import dayjs from 'dayjs';
import liveIcon1 from '@/assets/images/live-icon1.png';
import { useNavigate } from 'react-router-dom';


const GoLiveNow: React.FC = () => {
  const dispatch = useAppDispatch();
  const { message } = App.useApp();
  const navigate = useNavigate();
  // 直播表单状态
  const [liveTitle, setLiveTitle] = useState('');
  const [liveStartTime, setLiveStartTime] = useState<any>(null);
  const [liveEndTime, setLiveEndTime] = useState<any>(null);
  const [audioSwitch, setAudioSwitch] = useState(true);
  const [videoSwitch, setVideoSwitch] = useState(true);
  const [productShowcase, setProductShowcase] = useState(true);
  const [beautyTool, setBeautyTool] = useState(true);
  
  // 美颜功能状态
  const [skinSmoothing, setSkinSmoothing] = useState(0);
  const [whitening, setWhitening] = useState(0);
  const [faceSlimming, setFaceSlimming] = useState(0);
  const [rosy, setRosy] = useState(0);
  const [filterFunction, setFilterFunction] = useState('Retro');
  const [oneTouchMakeup, setOneTouchMakeup] = useState(true);
  const [depthOfFieldEffect, setDepthOfFieldEffect] = useState(true);
  const [dynamicStickers, setDynamicStickers] = useState('Retro');

  // 处理开始直播
  const handleStartLive = () => {
    navigate('/goLiveNowVideo');
    if (!liveTitle) {
      message.error('Live Title is required');
      return;
    }
    if (!liveStartTime) {
      message.error('Live Start Time is required');
      return;
    }
    if (!liveEndTime) {
      message.error('Live End Time is required');
      return;
    }

    if (liveStartTime > liveEndTime) {
      message.error('Live Start Time must be before Live End Time');
      return;
    }
    // if (!audioSwitch) {
    //   message.error('Audio Switch is required');
    //   return;
    // }
    // if (!videoSwitch) {
    //   message.error('Video Switch is required');
    //   return;
    // }
    // if (!productShowcase) {
    //   message.error('Product Showcase is required');
    //   return;
    // }
    // if (!beautyTool) {
    //   message.error('Beauty Tool is required');
    //   return;
    // }
    // if (!skinSmoothing) {
    //   message.error('Skin Smoothing is required');
    //   return;
    // }
    // if (!whitening) {
    //   message.error('Whitening is required');
    //   return;
    // }
    // if (!faceSlimming) {
    //   message.error('Face Slimming is required');
    //   return;
    // }
    // if (!rosy) {
    //   message.error('Rosy is required');
    //   return;
    // }
    // if (!filterFunction) {
    //   message.error('Filter Function is required');
    //   return;
    // }
    // if (!oneTouchMakeup) {
    //   message.error('One Touch Makeup is required');
    //   return;
    // }
    // if (!depthOfFieldEffect) {
    //   message.error('Depth Of Field Effect is required');
    //   return;
    // }
    // if (!dynamicStickers) {
    //   message.error('Dynamic Stickers is required');
    //   return;
    // }
   
    const liveData = {
      liveTitle,
      liveStartTime: liveStartTime ? liveStartTime.format('MM/DD/YYYY h:mm A') : '',
      liveEndTime: liveEndTime ? liveEndTime.format('MM/DD/YYYY h:mm A') : '',
      audioSwitch,
      videoSwitch,
      productShowcase,
      beautyTool,
      beautySettings: {
        skinSmoothing,
        whitening,
        faceSlimming,
        rosy,
        filterFunction,
        oneTouchMakeup,
        depthOfFieldEffect,
        dynamicStickers
      }
    };
    console.log('开始直播，直播配置:', liveData);
    // 这里可以调用开始直播的API
  };

  //mounted 和unmounted
  useEffect(() => {
    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, []);


  return (
    <div className={styles['go-live-container']}>
      <div className={styles['live-form']}>
        <div className={styles['form-header']}>
          <h1 className={styles['page-title']}>Go Live Now</h1>
          
        </div>

        {/* Live Title */}
        <div className={styles['form-section']}>
          <h3 className={styles['section-title']}>Live Title</h3>
          <div className={styles['title-input-container']}>
            <Input
              value={liveTitle}
              onChange={(e) => setLiveTitle(e.target.value)}
              className={styles['title-input']}
              placeholder="Live Title"
            />
            <span className={styles['char-count']}>{liveTitle.length}/30</span>
          </div>
        </div>

        {/* Live Time Slot */}
        <div className={styles['form-section']}>
          <h3 className={styles['section-title']}>Live Time Slot</h3>
          <div className={styles['time-slot-container']}>
            <div className={styles['time-input-group']}>
              <label className={styles['time-label']}>Live Start Time</label>
              <DatePicker
                showTime={{ format: 'h:mm A' }}
                format="MM/DD/YYYY h:mm A"
                value={liveStartTime}
                onChange={(date) => setLiveStartTime(date)}
                className={styles['time-input']}
                placeholder="Select start time"
              />
            </div>
            <div className={styles['time-input-group']}>
              <label className={styles['time-label']}>Live End Time</label>
              <DatePicker
                showTime={{ format: 'h:mm A' }}
                format="MM/DD/YYYY h:mm A"
                value={liveEndTime}
                onChange={(date) => setLiveEndTime(date)}
                className={styles['time-input']}
                placeholder="Select end time"
              />
            </div>
          </div>
        </div>

        {/* Switches Section */}
        <div className={styles['switches-container']}>
          {/* Audio Switch */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>* Audio Switch</span>
            <Radio.Group
              value={audioSwitch ? 'On' : 'Off'}
              onChange={(e) => setAudioSwitch(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>On</Radio>
              <Radio value="Off" className={styles['radio-option']}>Off</Radio>
            </Radio.Group>
          </div>

          {/* Video Switch */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>* Video Switch</span>
            <Radio.Group
              value={videoSwitch ? 'On' : 'Off'}
              onChange={(e) => setVideoSwitch(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>On</Radio>
              <Radio value="Off" className={styles['radio-option']}>Off</Radio>
            </Radio.Group>
          </div>

          {/* Product Showcase */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>* Product Showcase</span>
            <Radio.Group
              value={productShowcase ? 'On' : 'Off'}
              onChange={(e) => setProductShowcase(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>On</Radio>
              <Radio value="Off" className={styles['radio-option']}>Off</Radio>
            </Radio.Group>
          </div>

          {/* Beauty Tool */}
          <div className={styles['switch-item']}>
            <span className={styles['switch-label']}>Beauty Tool</span>
            <Radio.Group
              value={beautyTool ? 'On' : 'Off'}
              onChange={(e) => setBeautyTool(e.target.value === 'On')}
              className={styles['radio-group']}
            >
              <Radio value="On" className={styles['radio-option']}>On</Radio>
              <Radio value="Off" className={styles['radio-option']}>Off</Radio>
            </Radio.Group>
          </div>
        </div>

        {/* Beauty Tool Settings */}
        {beautyTool && (
          <div className={styles['beauty-section']}>
            <h4 className={styles['beauty-title']}>Basic Beauty Functions</h4>
            
            <div className={styles['beauty-controls']}>
              <div className={styles['beauty-control-group']}>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>Skin Smoothing (%)</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={skinSmoothing}
                    onChange={(value) => setSkinSmoothing(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>Whitening (%)</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={whitening}
                    onChange={(value) => setWhitening(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>Face Slimming (%)</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={faceSlimming}
                    onChange={(value) => setFaceSlimming(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
              </div>

              <div className={styles['beauty-control-group']}>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>Rosy (%)</label>
                  <InputNumber
                    min={0}
                    max={100}
                    value={rosy}
                    onChange={(value) => setRosy(value || 0)}
                    className={styles['number-input']}
                  />
                </div>
                <div className={styles['control-item']}>
                  <label className={styles['control-label']}>Filter Functions</label>
                  <Select
                    value={filterFunction}
                    onChange={setFilterFunction}
                    className={styles['select-input']}
                    options={[
                      { value: 'Retro', label: 'Retro' },
                      { value: 'Vintage', label: 'Vintage' },
                      { value: 'Natural', label: 'Natural' },
                    ]}
                  />
                </div>
                <div className={styles['control-item']}>
                  {/* 占位符，保持布局对称 */}
                </div>
              </div>
            </div>

            <h4 className={styles['beauty-title']}>Other Functions</h4>
            <div className={styles['other-functions']}>
              <div className={styles['function-item']}>
                <span className={styles['function-label']}>One-Touch Makeup</span>
                <Radio.Group
                  value={oneTouchMakeup ? 'On' : 'Off'}
                  onChange={(e) => setOneTouchMakeup(e.target.value === 'On')}
                  className={styles['radio-group']}
                >
                  <Radio value="On" className={styles['radio-option']}>On</Radio>
                  <Radio value="Off" className={styles['radio-option']}>Off</Radio>
                </Radio.Group>
              </div>

              <div className={styles['function-item']}>
                <span className={styles['function-label']}>Depth Of Field Effect</span>
                <Radio.Group
                  value={depthOfFieldEffect ? 'On' : 'Off'}
                  onChange={(e) => setDepthOfFieldEffect(e.target.value === 'On')}
                  className={styles['radio-group']}
                >
                  <Radio value="On" className={styles['radio-option']}>On</Radio>
                  <Radio value="Off" className={styles['radio-option']}>Off</Radio>
                </Radio.Group>
              </div>

              <div className={styles['function-item']}>
                <span className={styles['function-label']}>Dynamic Stickers</span>
                <Select
                  value={dynamicStickers}
                  onChange={setDynamicStickers}
                  className={styles['select-input']}
                  options={[
                    { value: 'Retro', label: 'Retro' },
                    { value: 'Cute', label: 'Cute' },
                    { value: 'Cool', label: 'Cool' },
                  ]}
                />
              </div>
            </div>
          </div>
        )}

        {/* Start Live Button */}
        <div className={styles['start-live-section']}>
          <Button
            type="primary"
            size="large"
            onClick={handleStartLive}
            className={styles['start-live-button']}
          >
            Start Live Now
          </Button>
        </div>
      </div>

      {/* Right side - Preview */}
      <div className={styles['preview-section']}>
        <img className='w-full h-auto' src={liveIcon1} alt="liveIcon1" />
      </div>
    </div>
  );
};

export default GoLiveNow; 

